import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"url(#warning_svg__a)\" d=\"M0 8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"></path><path fill=\"currentColor\" d=\"M22.185 16.056a2.089 2.089 0 0 1 3.63 0l7.9 13.77C34.523 31.232 33.516 33 31.9 33H16.1c-1.616 0-2.623-1.767-1.815-3.175zM23 29h2v-2h-2zm1-8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1\"></path><defs><linearGradient id=\"warning_svg__a\" x1=\"0\" x2=\"48\" y1=\"0\" y2=\"48\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#A45128\" stop-opacity=\".64\"></stop><stop offset=\"1\" stop-color=\"#A45128\" stop-opacity=\".08\"></stop></linearGradient></defs>", 3)
  ]))]))
}
export default { render: render }